/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
//import { environment } from '../environments/environment';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { EnvironmentService } from './service/environnement.service';
import { PingService } from './service/ping.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private environmentService: EnvironmentService, private analytics: AnalyticsService, private seoService: SeoService, private pingService: PingService) {
  }

  /** Applique les URLs backend (utilisé après ping réussi ou en fallback). */
  private applyBackendUrls(): void {
    this.environmentService.backend_url_Pos = `https://be.adcaisse.online/bp-api-pos/v1/`;
    this.environmentService.backend_url_Admin = `https://be.adcaisse.online/bp-api-admin/v1/`;
    this.environmentService.backend_url_Product = `https://be.adcaisse.online/bp-api-product/v1/`;
    this.environmentService.backend_url_Transaction = `https://be.adcaisse.online/bp-api-transaction/v1/`;
    this.environmentService.backend_url_Analytics = `https://be.adcaisse.online/bp-api-analytics/v1/`;
    this.environmentService.backend_url_Reservation = `https://be.adcaisse.online/bp-api-reservation/v1/`;
    this.environmentService.backend_url_loyality = `https://be.adcaisse.online/bp-api-loyality-v2/v1/`;
    this.environmentService.backend_url_customer = `https://be.adcaisse.online/bp-api-customer/v1/`;
    this.environmentService.backend_url_Notification = `https://be.adcaisse.online/bp-api-notification/v1/`;
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.pingService.findAvailableServer().subscribe(
      (availableServerUrl: string) => {
        if (availableServerUrl) {
          if (availableServerUrl === 'https://be1.adcaisse.online:8443/bp-api-admin/v1/findAllByIdPointVente/55')
            availableServerUrl = 'https://be1.adcaisse.online:8443';
          if (availableServerUrl === 'https://be.adcaisse.online/bp-api-admin/v1/findAllByIdPointVente/55')
            availableServerUrl = 'https://be.adcaisse.online';
        }
        this.applyBackendUrls();
      },
      () => {
        console.warn('Ping serveur en échec (certificat ou réseau). Utilisation des URLs backend par défaut.');
        this.applyBackendUrls();
      }
    );
  }
}
